import { z } from "zod";

export const sharedQueryResultSchema = z.object({
  id: z.string(),
  name: z.string(),
  created_on: z.string(),
  created_by: z.number(),
  share_url: z.string(),
  model_name: z.string(),
  attributes: z.object({
    rowsCount: z.number(),
    columnNames: z.array(z.string()),
  }),
});

export const sharedQueryResultDetailSchema = sharedQueryResultSchema.extend({
  sharing_status: z.boolean(),
  csv_result: z.string(),
  compiled_sql: z.string(),
});

export const sharedQueryResultListResponseSchema = z.object({
  items: z.array(sharedQueryResultSchema),
});

export const deleteQueryResultResponseSchema = z.object({
  ok: z.boolean(),
});

export type SharedQueryResult = z.infer<typeof sharedQueryResultSchema>;
export type SharedQueryResultDetail = z.infer<typeof sharedQueryResultDetailSchema>;
export type SharedQueryResultListResponse = z.infer<typeof sharedQueryResultListResponseSchema>;
export type DeleteQueryResultResponse = z.infer<typeof deleteQueryResultResponseSchema>;
